import { create } from 'zustand';

/**
 * Which Settings tab is open, or null when Settings is closed. One dialog serves the whole app, so
 * anything can open it on a tab: the seat dialogs open it on Subscription for billing and the card.
 */
interface SettingsDialogState {
  isOpen: boolean;
  tab?: string;
  openSettings: (tab?: string) => void;
  closeSettings: () => void;
}

export const useSettingsDialogStore = create<SettingsDialogState>((set) => ({
  isOpen: false,
  tab: undefined,
  openSettings: (tab) => set({ isOpen: true, tab }),
  closeSettings: () => set({ isOpen: false, tab: undefined }),
}));
